import { Loader2 } from 'lucide-react';

interface LoadingSpinnerProps {
  className?: string;
}

export function LoadingSpinner({ className }: LoadingSpinnerProps) {
  return (
    <div className="min-h-[inherit] flex items-center justify-center">
      <Loader2 className={`h-8 w-8 animate-spin text-gray-400 dark:text-gray-500 ${className || ''}`} />
    </div>
  );
}